import { Component, EventEmitter, Input, OnChanges, Output, Pipe, PipeTransform, SimpleChanges } from '@angular/core';
import { OriginAnchor } from '../../../model/synoptics/synoptic-arg-types';

@Component({
  selector: 'app-anchor-selector',
  templateUrl: './anchor-selector.component.html',
  styleUrls: ['./anchor-selector.component.scss']
})
export class AnchorSelectorComponent implements OnChanges{

  @Input() showHorizontal = true;
  @Input() showVertical = true;
  @Output() anchorChange = new EventEmitter<OriginAnchor>();

  public x: number;
  public y: number;

  constructor() {
    this.anchorChange = new EventEmitter<OriginAnchor>();
    this.x = 1;
    this.y = 1;
  }

  ngOnChanges(changes: SimpleChanges) {
    const { showHorizontal, showVertical } = changes;
    if (showHorizontal && showHorizontal.currentValue === false) {
      setTimeout(() => this.changeAnchor(1, this.y));
    }
    if (showVertical && showVertical.currentValue === false) {
      setTimeout(() => this.changeAnchor(this.x, 1));
    }
  }

  @Input()
  set anchor(anchor: OriginAnchor) {
    if (anchor) {
      const split = anchor.split(' ');
      this.y = split[0] === 'top' ? 2 : split[0] === 'center' ? 1 : 0;
      this.x = split[1] === 'right' ? 2 : split[1] === 'center' ? 1 : 0;
    } else {
      this.x = 1;
      this.y = 1;
    }
  }

  changeAnchor(x: number, y: number): void {
    this.x = x;
    this.y = y;
    this.anchorChange.emit(this.getAnchorFromCoordinates());
  }

  public getIcon(selfX: number, selfY: number): string {
    if (this.isCenter(selfX, selfY)) {
      return 'pi pi-circle';
    }
    const diffX = this.x - selfX;
    const diffY = this.y - selfY;
    if (Math.abs(diffX) > 1 || Math.abs(diffY) > 1) {
      return '';
    }
    const vertical = diffY == 1 ? '-down' : diffY == -1 ? '-up' : '';
    const horizontal = diffX == 1 ? '-left' : diffX == -1 ? '-right' : '';
    return `pi pi-arrow${vertical}${horizontal}`;
  }

  public isCenter(selfX: number, selfY: number): boolean {
    return selfX === this.x && selfY === this.y;
  }

  private getAnchorFromCoordinates(): OriginAnchor {
    const vertical = this.y == 2 ? 'top' : this.y == 1 ? 'center' : 'bottom';
    const horizontal = this.x == 2 ? 'right' : this.x == 1 ? 'center' : 'left';
    return (vertical + ' ' + horizontal) as OriginAnchor;
  }

}
